<template>
  <div
    role="dialog"
    class="popup fadein absolute h-full w-full z-151 flex justify-center items-center cursor-pointer"
    @pointerup.self="close()"
  >
    <div class="popup-wrapper w-3/4 flex flex-row-reverse rounded-xl bg-slate-middle cursor-default">
      <div
        tabindex="0"
        ref="firstFocus"
        class="h-6 w-6 mr-2 mt-3 p-1.5 bg-black rounded-full flex justify-center items-center cursor-pointer"
        @keydown.enter="close()"
        @pointerup.stop="close()"
      >
        <img class="w-5 h-5 invert rotate-45" :src="Close" />
      </div>
      <div class="flex flex-col items-start w-full h-full p-9 font-middle overflow-x-hidden">
        <img class="w-full h-full" :src="previewImage" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, nextTick, onMounted, PropType, ref } from 'vue'
  import { Note } from '@/common/classes'
  import { AttachmentType, baseUrl } from '@/constants'

  import BrokenImage from '@/assets/icons/fontawesome/image-slash-solid.svg'
  import Close from '@/assets/icons/fontawesome/plus-solid.svg'

  const props = defineProps({
    note: { type: Object as PropType<Note> | undefined, default: undefined },
  })

  const previewImage = computed(() => {
    if (props.note?.attachment?.url) {
      const url = props.note.attachment.url
      if (props.note.attachment.type === AttachmentType.image) return url
      else if (props.note.attachment.type === AttachmentType.external) return `${baseUrl}/api/file?url=${encodeURIComponent(url)}`
    }
    return BrokenImage
  })

  const emit = defineEmits<{
    (e: 'closePopup'): void
  }>()

  const firstFocus = ref()
  onMounted(() => {
    setTimeout(() => {
      firstFocus.value?.focus()
    }, 500)
  })

  function close() {
    emit('closePopup')
  }
</script>

<style scoped></style>
